import { AfterViewInit, Component, OnInit } from "@angular/core";
import { AlertController, ModalController } from "@ionic/angular";
import { take } from "rxjs/operators";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/angular-wallet-base/store/appState";
import { getSideMenuStatus } from "src/app/angular-wallet-base/store/appSettings";
import { DepositFundsModalComponent } from "../deposit-funds-modal/deposit-withdraw-funds-modal";
import { AppModeService } from "src/app/angular-wallet-base/services/app-mode.service";
import {
  bankAccountActionTypes,
  GetBankAccountBalanceRequest,
  GetBankAccountRequestAction,
  GetBankAccountTransactionHistoryRequest,
  GetBankAccountTransactionHistorySuccess,
  GetBankingHistoryAction,
} from "src/app/angular-wallet-base/actions/bankAccount.actions";
import { SubscriptionListenerComponent } from "src/app/angular-wallet-base/SubscriptionListenerComponent";
import {
  getBankAccountBalance,
  getBankAccountList,
  getBankAccountTransactionList,
  getBankingHistory,
  getBankingHistoryLoadedState,
} from "src/app/angular-wallet-base/store/bankAccounts";
import { Actions, ofType } from "@ngrx/effects";
import { takeUntil } from "rxjs/operators";
import { BankAccountService } from "src/app/angular-wallet-base/services/bank-account.service";
import { TranslateService } from "@ngx-translate/core";
import { Logger } from "src/app/angular-wallet-base/services/logger.service";

@Component({
  selector: "usd-balance-home-modal",
  templateUrl: "./usd-balance-modal.html",
  styleUrls: ["./usd-balance-modal.scss"],
})
// tslint:disable-next-line: component-class-suffix
export class USDBalanceHomeModal extends SubscriptionListenerComponent implements OnInit {
  public listTransaction = [];
  public status: any = {};
  public isDesktopMode;
  public bankAccounts = [];
  public showLoader = false;
  public dataLoader = false;
  public expandTxns = false;
  public baseToken = "USD";
  public fiatBalance: any = 0;
  public disbursableDetails;
  public disbursableDetailsList = [];
  public updatedAt;
  public bankHistoryProgress = false;
  public loadedAllHistories = false;
  constructor(
    protected store: Store<AppState>,
    private bankAccountService: BankAccountService,
    public alertController: AlertController,
    public appMode: AppModeService,
    private actions$: Actions,
    public modalController: ModalController,
    private translate: TranslateService
  ) {
    super(store);

    this.appMode.isDesktopMode.subscribe((mode) => (this.isDesktopMode = mode));
  }

  async ngOnInit() {
    this.disbursableDetails = await this.bankAccountService.getBankAccountsBalanceFor();

    Object.keys(this.disbursableDetails).map(async (x, i) => {
      this.disbursableDetailsList.push({
        key: x.replace(/[^a-zA-Z0-9 ]/g, "_"),
        label: "prime_usd_expanded.label" + x.replace(/[^a-zA-Z0-9 ]/g, "_"),
        value: this.disbursableDetails[x],
        des: "prime_usd_expanded." + x.replace(/[^a-zA-Z0-9 ]/g, "_"),
      });
    });
    this.store.dispatch(new GetBankAccountTransactionHistoryRequest());
    this.updatedAt = this.disbursableDetailsList.find((data) => ["updated_at"].includes(data.key));
    this.disbursableDetailsList = this.disbursableDetailsList.filter((data) =>
      ["contingent_hold", "settled", "pending_transfer", "disbursable"].includes(data.key)
    );
    this.store.dispatch(new GetBankAccountBalanceRequest());
    if (this.baseToken == "USD") {
      this.getBankAccounts();
      this.subscriptions.add(
        this.store.select(getBankAccountBalance).subscribe((bankAccountBalance) => {
          this.fiatBalance = bankAccountBalance.amount;
        })
      );
    }
    //need to remove
    this.subscriptions.add(
      this.store.select(getBankAccountTransactionList).subscribe(async (transactions) => {
        this.listTransaction = transactions.data;
      })
    );
    // this.subscriptions.add(this.store.select(getBankingHistory).subscribe(async (transactions) => {
    //   this.listTransaction = transactions;
    // }));

    // this.subscriptions.add(
    //   this.bankAccountService.bankingHistoryProgress.subscribe(status => {
    //     this.bankHistoryProgress = status;
    //   })
    // );
    // this.subscriptions.add(
    //   this.store.select(getBankingHistoryLoadedState).subscribe(status => {
    //     this.loadedAllHistories = status;
    //   })
    // );

    this.status.cancelled = await this.translate.get("deposit_success_fail.cancelled").toPromise();
    this.status.pending = await this.translate.get("deposit_success_fail.pending").toPromise();
    this.status.refunded = await this.translate.get("deposit_success_fail.refunded").toPromise();
    this.status.complete = await this.translate.get("deposit_success_fail.complete").toPromise();

    this.status.deposit = await this.translate.get("deposit_success_fail.deposit").toPromise();
    this.status.withdraw = await this.translate.get("deposit_success_fail.withdraw").toPromise();
    this.status.exchange = await this.translate.get("deposit_success_fail.exchange").toPromise();
    this.subscriptions.add(
      this.bankAccountService.transactionLoader.subscribe((res) => {
        this.showLoader = res;
      })
    );
  }
  loadMore() {
    if (!this.bankHistoryProgress) {
      Logger.info("loading more .  . .");
      this.store.dispatch(new GetBankingHistoryAction());
    }
  }
  close() {
    this.modalController.dismiss();
  }
  getBankAccounts() {
    this.subscriptions.add(
      this.store.select(getBankAccountList).subscribe((bankAccount) => {
        this.bankAccounts = bankAccount.data;
      })
    );
  }
  async openDepositWithdrawFundsModal(action) {
    this.modalController.dismiss();
    let cssClass = "";
    const sideMenuHidden = await this.store.select(getSideMenuStatus).pipe(take(1)).toPromise();
    cssClass += this.isDesktopMode ? "deposit-modal-desktop" : "deposit-modal";
    cssClass += !sideMenuHidden && this.isDesktopMode ? " with-side-menu" : "";
    const modal = await this.modalController.create({
      component: DepositFundsModalComponent,
      cssClass,
      componentProps: {
        action: action,
        bankAccounts: this.bankAccounts,
      },
      initialBreakpoint: this.isDesktopMode ? undefined : 0.6,
      breakpoints: this.isDesktopMode ? undefined : [0, 0.4, 0.6, 1],
      id: "depositFundsModal",
    });
    await modal.present();
  }

  objectParse(obj) {
    switch (obj.transferSubject) {
      case "exchange":
        switch (obj.direction) {
          case "EXCHANGE_FIAT_TO_TOKEN":
            return {
              text: this.status.exchange,
              amount: obj["subject1"].amount,
              currency: obj["subject1"].name,
              amount2: obj["subject0"].amount,
              currency2: obj["subject0"].name,
              direction: "EXCHANGE_FIAT_TO_TOKEN",
            };
          case "EXCHANGE_TOKEN_TO_FIAT":
            return {
              text: this.status.exchange,
              amount: obj["subject0"].amount,
              currency: obj["subject0"].name,
              amount2: obj["subject1"].amount,
              currency2: obj["subject1"].name,
              direction: "EXCHANGE_TOKEN_TO_FIAT",
            };
        }
      case "fiat":
        return {
          text: obj.amount > 0 ? this.status.deposit : this.status.withdraw,
          amount: obj.amount,
          currency: obj.currencyName,
          amount2: obj["subject1"] ? obj["subject1"].amount : "",
          currency2: obj["subject1"] ? obj["subject1"].name : "",
        };
    }
  }
  statusParse(status) {
    switch (status) {
      case "pending":
        return { text: this.status.pending, color: "yellow" };
      case "refunded":
        return { text: this.status.refunded, color: "blue" };
      case "cancelled":
        return { text: this.status.cancelled, color: "red" };
      case "settled":
        return { text: this.status.complete, color: "green" };
      case "complete":
        return { text: this.status.complete, color: "green" };
    }
  }
}
